import { XHRConnectionError } from './connection';
import {
	CHANGE_NETWORK_STATE,
	CHUNK_LOADING_ERROR,
	NETWORK_FETCH_REQUEST_ERROR,
	NETWORK_INTERCEPTION_ERROR,
	NETWORK_SAVE_REQUEST_ERROR,
} from './connection.actionTypes';

export const actionCreators = {
	doSetOnline: () => ({
		type: CHANGE_NETWORK_STATE,
		online: true,
	}),
	doSetOffline: () => ({
		type: CHANGE_NETWORK_STATE,
		online: false,
	}),
	doTrackNetworkInterceptionError: (request: XHRConnectionError) => ({
		type: NETWORK_INTERCEPTION_ERROR,
		request,
	}),
	doTrackNetworkFetchRequestError: () => ({
		type: NETWORK_FETCH_REQUEST_ERROR,
	}),
	doTrackNetworkSaveRequestError: () => ({
		type: NETWORK_SAVE_REQUEST_ERROR,
	}),
	doTrackChunkLoadingError: (error: Error, component: string) => ({
		type: CHUNK_LOADING_ERROR,
		component,
		error,
	}),
};

export type ConnectionActionType =
	| ReturnType<typeof actionCreators.doSetOnline>
	| ReturnType<typeof actionCreators.doSetOffline>
	| ReturnType<typeof actionCreators.doTrackNetworkInterceptionError>
	| ReturnType<typeof actionCreators.doTrackNetworkFetchRequestError>
	| ReturnType<typeof actionCreators.doTrackNetworkSaveRequestError>
	| ReturnType<typeof actionCreators.doTrackChunkLoadingError>;
